import {effect, inject, Injectable} from "@angular/core";
import {MatDatepickerIntl} from "@angular/material/datepicker";
import {TranslateService} from "@ngx-translate/core";
import {TranslateHelperService} from "./translate-helper.service";

@Injectable({
    providedIn: "root",
})
export class DatepickerInternationalization extends MatDatepickerIntl {
    private readonly translateService = inject(TranslateService);
    private readonly translateHelperService = inject(TranslateHelperService);
    private readonly langChanged = this.translateHelperService.lang;

    protected translationKeys = new Map<string, { translationKey: string }>([
        ["calendarLabel", {translationKey: "general.datepicker.calendar"}],
        ["closeCalendarLabel", {translationKey: "general.datepicker.close-calendar"}],
        ["comparisonDateLabel", {translationKey: "general.datepicker.comparison-range"}],
        ["nextMonthLabel", {translationKey: "general.datepicker.next-month"}],
        ["nextMultiYearLabel", {translationKey: "general.datepicker.next-multi-year"}],
        ["nextYearLabel", {translationKey: "general.datepicker.next-year"}],
        ["openCalendarLabel", {translationKey: "general.datepicker.open-calendar"}],
        ["prevMonthLabel", {translationKey: "general.datepicker.previous-month"}],
        ["prevMultiYearLabel", {translationKey: "general.datepicker.previous-multi-year"}],
        ["prevYearLabel", {translationKey: "general.datepicker.previous-year"}],
        ["switchToMonthViewLabel", {translationKey: "general.datepicker.switch-to-month-view"}],
        ["switchToMultiYearViewLabel", {translationKey: "general.datepicker.switch-to-multi-year-view"}],
    ]);

    constructor() {
        super();
        this.translateLabels();
        effect(() => {
            if (this.langChanged()) {
                this.translateLabels();
            }
        });
    }

    /* eslint-disable @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-non-null-assertion */
    private translateLabels(): void {
        this.calendarLabel = this.translateService.instant(this.translationKeys.get("calendarLabel")!.translationKey);
        this.closeCalendarLabel = this.translateService.instant(this.translationKeys.get("closeCalendarLabel")!.translationKey);
        this.comparisonDateLabel = this.translateService.instant(this.translationKeys.get("comparisonDateLabel")!.translationKey);
        this.nextMonthLabel = this.translateService.instant(this.translationKeys.get("nextMonthLabel")!.translationKey);
        this.nextMultiYearLabel = this.translateService.instant(this.translationKeys.get("nextMultiYearLabel")!.translationKey);
        this.nextYearLabel = this.translateService.instant(this.translationKeys.get("nextYearLabel")!.translationKey);
        this.openCalendarLabel = this.translateService.instant(this.translationKeys.get("openCalendarLabel")!.translationKey);
        this.prevMonthLabel = this.translateService.instant(this.translationKeys.get("prevMonthLabel")!.translationKey);
        this.prevMultiYearLabel = this.translateService.instant(this.translationKeys.get("prevMultiYearLabel")!.translationKey);
        this.prevYearLabel = this.translateService.instant(this.translationKeys.get("prevYearLabel")!.translationKey);
        this.switchToMonthViewLabel = this.translateService.instant(this.translationKeys.get("switchToMonthViewLabel")!.translationKey);
        this.switchToMultiYearViewLabel = this.translateService.instant(this.translationKeys.get("switchToMultiYearViewLabel")!.translationKey);
        this.changes.next();
    }
    /* eslint-enable @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-non-null-assertion */
}